import { useState } from "react";
import Form from "react-bootstrap/Form";
import StarRating from "./rate";
import translateText, { currentLanguage } from "../signals/language.signal";
import { logToken } from "../signals/login.signal";
import { primary, primaryFount } from "../signals/Theme colors.signal";
import CloseIcon from "@mui/icons-material/Close";
import { Alert, Collapse, IconButton } from "@mui/material";

const RateBox = () => {
  const [rateService, setRateService] = useState("");
  const [rateProduct, setRateProduct] = useState("");
  const [rateRep, setRateRep] = useState("");
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [alertMessageType, setAlertMessageType] = useState("error");

  const showAlertMessage = (MSG, type) => {
    setAlertMessage(MSG);
    setAlertMessageType(type);
    setOpen(true);
    setTimeout(() => {
      setOpen(false);
    }, 3000);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    const form = event.currentTarget;

    if (form.checkValidity() === false) {
      event.stopPropagation();
    } else {
      try {
        setLoading(true);
        const bearerToken = logToken.value;
        const response = await fetch(
          "https://alguthmi.co/API/B2BAppAPI/insertEvaluation.php",
          {
            method: "POST",
            headers: {
              Authorization: `Bearer ${bearerToken}`,
              origin: "http://alguthmi.co",
            },
            body: JSON.stringify({
              EVALUATION_SERVICE: rateService,
              EVALUATION_PRODUCT: rateProduct,
              EVALUATION_REPRESENTATIVE: rateRep,
            }),
          }
        );

        if (response.ok) {
          showAlertMessage("Evaluation Send", "success");
          form.reset();
          setRateService(0);
          setRateProduct(0);
          setRateRep(0);
        } else {
          showAlertMessage("Authentication failed", "error");
        }
      } catch (error) {
        console.error("Error:", error);
        showAlertMessage("Error submitting form. Please try again.", "error");
      } finally {
        setLoading(false);
      }
    }
  };

  return (
    <>
      <Collapse
        in={open}
        className="position-fixed m-2"
        style={{ zIndex: 1000, direction: "ltr", top: 0 }}
      >
        <Alert
          severity={alertMessageType}
          variant="filled"
          action={
            <IconButton
              aria-label="close"
              color="inherit"
              size="small"
              className="m-0"
              onClick={() => {
                setOpen(false);
              }}
            >
              <CloseIcon fontSize="inherit" className="m-0" />
            </IconButton>
          }
          sx={{ mb: 2 }}
        >
          {alertMessage}
        </Alert>
      </Collapse>
      <div className="align-items-sm-center d-flex justify-content-center w-100 p-3">
        <div className="loginContaner bg-white p-3 p-md-5 w-100 shadow rounded-3 d-flex justify-content-center align-items-center">
          <Form onSubmit={handleSubmit} className="w-100">
            <div className="mb-3 rounded-3 p-2 border">
              <label htmlFor="clientCode" className="form-label">
                {translateText(currentLanguage.value, "Service")}
              </label>
              <StarRating
                key={rateService} // Add key prop here
                maxStars={5}
                initialRating={0}
                value={rateService} // Pass value prop instead of initialRating
                onRatingChange={(rating) => setRateService(rating)}
                disabled={loading}
              />
            </div>
            <div className="mb-3 rounded-3 p-2 border">
              <label htmlFor="clientCode" className="form-label">
                {translateText(currentLanguage.value, "Product")}
              </label>
              <StarRating
                key={rateProduct} // Add key prop here
                maxStars={5}
                initialRating={0}
                value={rateProduct} // Pass value prop instead of initialRating
                onRatingChange={(rating) => setRateProduct(rating)}
                disabled={loading}
              />
            </div>
            <div className="mb-3 rounded-3 p-2 border">
              <label htmlFor="clientCode" className="form-label">
                {translateText(currentLanguage.value, "Representative")}
              </label>
              <StarRating
                key={rateRep} // Add key prop here
                maxStars={5}
                initialRating={0}
                value={rateRep} // Pass value prop instead of initialRating
                onRatingChange={(rating) => setRateRep(rating)}
                disabled={loading}
              />
            </div>
            <button
              type="submit"
              className="btn btn-primary border pe-3 ps-3 w-100"
              style={{ background: primary.value, color: primaryFount.value }}
              disabled={loading}
            >
              {loading
                ? translateText(currentLanguage.value, "Loading") + "..."
                : translateText(currentLanguage.value, "Send")}
            </button>
          </Form>
        </div>
      </div>
    </>
  );
};

export default RateBox;
